import cslx from 'clsx';
import { ContractStatus } from '../types';

interface ContractStatusPillProps {
  status: ContractStatus;
  t: any;
  className?: string;
}

const propsByStatus: {
  [key in ContractStatus]: {
    styles: string;
  };
} = {
  CANCELLED: {
    styles: 'bg-[#FEF3F2] text-[#B42318]',
  },
  CONFIRMED: {
    styles: 'bg-secondary-green text-primary-green',
  },
  DRAFT: {
    styles: 'bg-secondary-grey text-primary-dark',
  },
  FULLFILLED: {
    styles: 'bg-secondary-green text-primary-green',
  },
  PARTIALLY_FULFILLED: {
    styles: 'bg-[#EDEDFD] text-secondary-blue',
  },
};

const ContractStatusPill: React.FC<ContractStatusPillProps> = (props) => {
  const { t, className = '' } = props;

  return (
    <div
      className={cslx(
        className,
        propsByStatus[props.status].styles,
        'capitalize rounded-8-0 px-1-4 py-0-4 text-2-0 md:text-1-4 font-md inline-block',
      )}
    >
      <span>{t(`contracts.status.${props.status.toLowerCase()}`)}</span>
    </div>
  );
};

export default ContractStatusPill;
